import React, { useState, useEffect } from 'react';
import { supabase } from '../supabase';

export function AdminPanel({ onBack }) {
  const [profiles, setProfiles] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const [editValue, setEditValue] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    supabase.from('profiles').select('*').order('username').then(({ data, error }) => {
      if (!error) setProfiles(data || []);
    });
  }, []);

  const startEdit = (profile) => {
    setEditingId(profile.id);
    setEditValue(profile.username);
    setError('');
  };

  const saveEdit = async (id) => {
    const trimmed = editValue.trim();
    if (!trimmed) { setError('Username cannot be empty.'); return; }
    const { error } = await supabase.from('profiles').update({ username: trimmed }).eq('id', id);
    if (error) {
      setError(error.message.includes('unique') ? 'That username is already taken.' : error.message);
    } else {
      setProfiles(profiles.map(p => p.id === id ? { ...p, username: trimmed } : p));
      setEditingId(null);
    }
  };

  return (
    <div className="leaderboard-container">
      <h1>Admin Panel</h1>
      <p style={{ color: '#888', fontSize: 14, marginTop: -8 }}>Manage all player usernames</p>
      {error && <div className="error" style={{ maxWidth: 520 }}>{error}</div>}
      <table className="leaderboard-table">
        <thead>
          <tr>
            <th>Username</th>
            <th>Admin</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {profiles.map((p) => (
            <tr key={p.id}>
              <td>
                {editingId === p.id ? (
                  <input
                    value={editValue}
                    onChange={(e) => setEditValue(e.target.value)}
                    autoFocus
                    style={{ padding: '5px 10px', borderRadius: 6, border: '1px solid #e0e0e0', fontFamily: 'inherit', fontSize: 14, width: '100%' }}
                    onKeyDown={(e) => { if (e.key === 'Enter') saveEdit(p.id); if (e.key === 'Escape') setEditingId(null); }}
                  />
                ) : (
                  p.username
                )}
              </td>
              <td>{p.is_admin ? 'Yes' : '—'}</td>
              <td style={{ textAlign: 'right' }}>
                {editingId === p.id ? (
                  <>
                    <button onClick={() => saveEdit(p.id)} className="btn btn-submit" style={{ padding: '5px 12px', margin: '0 3px', fontSize: 13 }}>Save</button>
                    <button onClick={() => setEditingId(null)} className="btn" style={{ padding: '5px 12px', fontSize: 13 }}>Cancel</button>
                  </>
                ) : (
                  <button onClick={() => startEdit(p)} className="btn" style={{ padding: '5px 12px', fontSize: 13 }}>Edit</button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <button onClick={onBack} className="btn btn-play">Back to Game</button>
    </div>
  );
}